import { I18n } from '@calendly/i18n';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { HeadingText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import changeSet from 'core/change_set';
import { useEventTypeEditorSidebar } from '../hooks';
import { useSelectedSections } from './components/selected_sections';
import { usePreviewSidePanel } from '../preview_side_panel/context';
const containerCss = "cn8dgxu";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const oldHeaderContainerCss = "o1jnz5hq";
const OldHeaderContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(oldHeaderContainerCss, props.className)} />;
});
export const Header = ({
  sectionTitle
}) => {
  const isPhone = useDeviceType('isPhone');
  const {
    selectedSections,
    closeCurrentSection
  } = useSelectedSections();
  const {
    isPreviewSidePanelOpen,
    togglePreviewSidePanel
  } = usePreviewSidePanel();
  const {
    closeSidebar: closeEventTypeSidebar
  } = useEventTypeEditorSidebar();
  const dispatchClose = () => {
    if (selectedSections.length > 1) {
      closeCurrentSection();
    } else {
      closeEventTypeSidebar({
        resetAlert: true
      });
    }
  };
  const handleClose = () => {
    if (isPhone && isPreviewSidePanelOpen) {
      togglePreviewSidePanel();
      return;
    }
    if (!changeSet.confirmReset()) return;
    dispatchClose();
  };
  const closeButtonTitle = isPhone && isPreviewSidePanelOpen ? I18n.t('publisher.action.close') : I18n.t('publisher.action.cancel');
  return <>
      <Container>
        <IconButton size="small" title={closeButtonTitle} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Container>
      {sectionTitle && <OldHeaderContainer>
          <HeadingText level={1} size="medium" data-testid="event-name-display">
            {sectionTitle}
          </HeadingText>
        </OldHeaderContainer>}
    </>;
};

require("./header.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");